"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = exports.LabelContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const R = __importStar(require("ramda"));
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
exports.LabelContainer = styled_components_1.default.span `
  ${style_1.default.Text.Definition.Label};
  color: ${props => R.propOr(props.theme.Color.Text.Secondary, 'color', props)};
`;
const Label = ({ children, color, }) => {
    return ((0, jsx_runtime_1.jsx)(exports.LabelContainer, Object.assign({ color: color }, { children: children })));
};
exports.Label = Label;
